module.exports = __webpack_public_path__ + "static/media/dwk.ef2ff797.mp4";